import { useState } from "react"
import { Fetch } from "../../services/api"
import { notify } from "../../utils/utils"

const urlReporte = process.env.REACT_APP_XPROJECT_API + "/Report";
export const useReportes = () => {
    const reportesDefault = [
        {tituloReporte: 'Reporte de actividades del personal', nomReporte: 'Reporte 001', codigoReporte: 'RP001' },
        {tituloReporte: 'Reporte consolidado', nomReporte: 'Reporte 002', codigoReporte: 'RP002' },
        {tituloReporte: 'Reporte de monitoreo de actividades', nomReporte: 'Reporte 003', codigoReporte: 'RP003' },
        {tituloReporte: 'Reporte de monitoreo de requerimientos', nomReporte: 'Reporte 004', codigoReporte: 'RP004' },
        {tituloReporte: 'Reporte de actividades por mes', nomReporte: 'Reporte 005', codigoReporte: 'RP005' },
        // {tituloReporte: 'Reporte 006', nomReporte: 'Reporte 006', codigoReporte: 'RP006' },
    ]
    const [reportes, setReportes ] = useState(reportesDefault)
    const [ rp01, setRp01 ] = useState([]);
    const [ rp02, setRp02 ] = useState([]);
    
    const listarReportes = async () => {
        try{
            const response = await Fetch()
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setReportes(response.isValid ? response.content : [])
        }
        catch(e){
            setReportes([]);
            notify('Ocurrió un error en el servicio','error');
            console.log('error al listar reportes: ',e)
        }
    }

    const listarRp01 = async (fechaIncio, fechaFin, codPersona, codArea) => {
        try
        {
            const response = await Fetch({
                url: urlReporte + '/report01?' + new URLSearchParams({
                    fechaInicio: fechaIncio,
                    fechaFin: fechaFin,
                    codPersona: codPersona,
                    codArea: codArea,
                })
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setRp01(response.isValid ? response.content : []);
        }
        catch(e){
            notify('Ocurrió un error en el servicio','error');
            setRp01([])
            console.log('Error al listar RP01: ',e)
        }
    }

    const listarRp02 = async (fechaIncio, fechaFin, codPersona) => {
        try
        {
            const response = await Fetch({
                url: urlReporte + '/report02?' + new URLSearchParams({
                    fechaInicio: fechaIncio,
                    fechaFin: fechaFin,
                    codPersona: codPersona,
                })
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setRp02(response.isValid ? response.content : []);
        }
        catch(e){
            notify('Ocurrió un error en el servicio','error');
            setRp02([])
            console.log('Error al listar RP01: ',e)
        }
    }



    return{
        listarReportes,
        reportes,
        listarRp01,
        rp01,
        listarRp02,
        rp02
    }
}